import React, { Component } from 'react';

import { connect } from 'react-redux';
import { formatPrice } from '../../services/util';
import { addCart, removeCart, updateCartName, selectCart, removeItemFromCart, updateCartItem, copyCart, changeFloatCartState } from '../../services/carts/actions';

import './style.scss';
import Bag from './Bags';
import { Accordion } from 'react-bootstrap';
import { BsArrowReturnRight, BsFillBagPlusFill } from 'react-icons/bs';

class FloatCart extends Component {
  constructor(props){
    super(props);
    this.state = {
      isOpen: true,
    };
  }

  openFloatCart = () => {
    this.setState({ isOpen: true });
  };

  closeFloatCart = () => {
    this.setState({ isOpen: false });
  };

  componentDidMount(){
    this.getSize();
  }

  getSize() {
    if( document.body.offsetWidth <= 991 ){
      if( this.props.floatCartState ){
        this.props.changeFloatCartState();
      }
    }
    else{
      if( !this.props.floatCartState ){
        this.props.changeFloatCartState();
      }
    }
  }

  proceedToCheckout = () => {
    window.alert(JSON.stringify(this.props.bags));
  };

  render() {
    const { cartTotal, bags, updateCartName, removeCart, addCart, activeBag, selectCart, updateCartItem, removeItemFromCart, copyCart, floatCartState, changeFloatCartState } = this.props;

    let totalAmount = 0;
    let total = 0;
    
    let classes = ['float-cart'];
    let wrapperClass = ["float-cart__wrapper"];

    if (!!floatCartState) {
      wrapperClass.push("float-cart__wrapper-open");
      classes.push('float-cart--open');
    }

    const bag = (
      bags.map(bag => {
        bag["items"].forEach(item => {
          total += item.quantity;
          totalAmount += item.quantity * item.price;
        });
        
        return (
          <Bag key={bag.id} bag={bag} removeCart={removeCart} updateCartName={updateCartName} activeBag={activeBag} selectCart={selectCart} updateCartItem={updateCartItem} removeItemFromCart={removeItemFromCart} copyCart={copyCart} />
        );
      })
    );

    return (
      <div className={wrapperClass.join(' ')}>
        <div className={classes.join(' ')}>
          {/* If cart open, show close (x) button */}
          {floatCartState && (
            <>
              <div
                onClick={() => changeFloatCartState()}
                className="float-cart__close-btn"
              >
                <BsArrowReturnRight />
              </div>
              <div
                className='float-cart__add-btn'
                onClick={() => addCart()}
              >
                <BsFillBagPlusFill />
              </div>
            </>
          )}

          {/* If cart is closed, show bag with quantity of product and open cart action */}
          {!this.props.floatCartState && (
            <span
              onClick={() => changeFloatCartState()}
              className="bag bag--float-cart-closed"
            >
              <span className="bag__quantity">{total}</span>
              <span className="bag__amount">{`${cartTotal.currencyFormat} ${formatPrice(
                    totalAmount,
                    cartTotal.currencyId
                  )}`}</span>
            </span>
          )}

          <div className="float-cart__content">
            <div className="float-cart__header">
              <span className="bag">
                <span className="bag__quantity">{total}</span>
              </span>
              <span className="header-title">Cart</span>
            </div>

            <div className="float-cart__shelf-container">
              <Accordion id="bagAccordion">
                {bag}
              </Accordion>
            </div>

            <div className="float-cart__footer">
              <div className="sub">SUBTOTAL</div>
              <div className="sub-price">
                <p className="sub-price__val">
                  {`${cartTotal.currencyFormat} ${formatPrice(
                    totalAmount,
                    cartTotal.currencyId
                  )}`}
                </p>
                <small className="sub-price__installment">
                  {!!cartTotal.installments && (
                    <span>
                      {`OR UP TO ${cartTotal.installments} x ${
                        cartTotal.currencyFormat
                      } ${formatPrice(
                        totalAmount / cartTotal.installments,
                        cartTotal.currencyId
                      )}`}
                    </span>
                  )}
                </small>
              </div>
              <div onClick={() => this.proceedToCheckout()} className="buy-btn">
                Checkout
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  cartTotal: state.total.data,
  bags: state.carts.bags,
  activeBag: state.carts.activeBag,
  floatCartState: state.carts.floatCartState
});

export default connect(
  mapStateToProps,
  { removeCart, updateCartName, addCart, selectCart, updateCartItem, removeItemFromCart, copyCart, changeFloatCartState }
)(FloatCart);
